module.exports = __webpack_public_path__ + "img/zhibobg.2c78d897.png";